import React from "react"
import './MainPage.scss'
import DocumentsDatesBlock from "../components/blocks/DocumentsDatesBlock";
import MaterialsBlock from "../components/blocks/MaterialsBlock";
import StartBlock from "../components/blocks/StartBlock";
import AboutBlock from "../components/blocks/AboutBlock";
import WinnersBlock from "../components/blocks/WinnersBlock";

function MainPage() {

    return (
        <div className="main-page">
            <StartBlock />
            <AboutBlock />
            <DocumentsDatesBlock targetDate="2026-09-15" />
            <MaterialsBlock />
            <WinnersBlock />
        </div>
    );
}

export default MainPage;